<div class="step-details" [ngClass]="{ 'modal-compact': !isFullMode }">
    <div class="modal-header"><cm-step-header [data]="initialStepData"></cm-step-header></div>

    <div [ngSwitch]="initialStepData.step_type_id" class="content-container">
        <cm-dynamic-details
            *ngSwitchCase="STEP_TYPES.DYNAMIC"
            class="step-content-modal"
            [formPageFirst]="workflowTypeId === WORKFLOW_MODULE_ID.TESTING_WORKFLOW"
            [step]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (toggleMode)="onModeToggle($event)"
            (updateStep)="updateStep()"
        >
        </cm-dynamic-details>
        <cm-dynamic-details
            *ngSwitchCase="STEP_TYPES.QUALIFICATION"
            class="step-content-modal"
            [formPageFirst]="true"
            [step]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (toggleMode)="onModeToggle($event)"
            (updateStep)="updateStep()"
        >
        </cm-dynamic-details>
        <cm-dynamic-details
            *ngSwitchCase="STEP_TYPES.ADA"
            class="step-content-modal"
            [formPageFirst]="true"
            [step]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (toggleMode)="onModeToggle($event)"
            (updateStep)="updateStep()"
        >
        </cm-dynamic-details>
        <cm-dynamic-details
            *ngSwitchCase="STEP_TYPES.FOLLOW_UP"
            class="step-content-modal"
            [formPageFirst]="true"
            [step]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (toggleMode)="onModeToggle($event)"
            (updateStep)="updateStep()"
        >
        </cm-dynamic-details>
        <cm-evidence-file-details
            *ngSwitchCase="STEP_TYPES.EVIDENCE_FILE"
            class="step-content-modal"
            [step]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (toggleMode)="onModeToggle()"
            (updateStep)="updateStep()"
        >
        </cm-evidence-file-details>
        <cm-fees-details
            *ngSwitchCase="STEP_TYPES.FEES"
            class="step-content-modal"
            [step]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (toggleMode)="onModeToggle()"
            (updateStep)="updateStep()"
        >
        </cm-fees-details>
        <cm-fees-details
            *ngSwitchCase="STEP_TYPES.TEST_FEE"
            class="step-content-modal"
            [step]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (toggleMode)="onModeToggle()"
            (updateStep)="updateStep()"
        >
        </cm-fees-details>
        <cm-test-details *ngSwitchCase="STEP_TYPES.TEST" class="step-content-modal" [step]="initialStepData"> </cm-test-details>
        <cm-registration-form-details
            *ngSwitchCase="STEP_TYPES.REGISTRATION_FORM"
            class="step-content-modal"
            [step]="initialStepData"
            (toggleMode)="onModeToggle($event)"
        >
        </cm-registration-form-details>
        <cm-log-details
            *ngSwitchCase="STEP_TYPES.LOG"
            (toggleMode)="onModeToggle($event)"
            class="step-content-modal"
            [logStep]="initialStepData"
            [workflowTypeId]="workflowTypeId"
            (updateStep)="updateStep()"
        >
        </cm-log-details>
        <cm-test-registration-details
            *ngSwitchCase="STEP_TYPES.TEST_REGISTRATION"
            class="step-content-modal"
            [step]="initialStepData"
            (updateStep)="updateStep()"
        >
        </cm-test-registration-details>
        <cm-license-details
            *ngSwitchCase="STEP_TYPES.LICENSE_VERIFICATION"
            class="step-content-modal"
            [step]="initialStepData"
            (updateStep)="updateStep()"
        >
        </cm-license-details>
        <cm-license-details
            *ngSwitchCase="STEP_TYPES.LICENSE_RENEWAL"
            class="step-content-modal"
            [step]="initialStepData"
            (updateStep)="updateStep()"
        >
        </cm-license-details>
        <cm-onboarding-details
            *ngSwitchCase="STEP_TYPES.ONBOARDING"
            class="step-content-modal"
            [step]="initialStepData"
            [additionalData]="additionalData"
        >
        </cm-onboarding-details>
    </div>
</div>
